(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileClose = document.querySelector('.header__mobile-close');
  const mobileOverlay = document.querySelector('.header__mobile-overlay');

  function openMenu() {
    mobileMenu.hidden = false;
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.hidden = true;
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !mobileMenu.hidden) closeMenu();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-carousel]').forEach(function(carousel) {
    var slides = Array.from(carousel.querySelectorAll('.product-hero__slide'));
    var thumbs = Array.from(carousel.querySelectorAll('.product-hero__thumb'));
    var prevBtn = carousel.querySelector('.product-hero__carousel-prev');
    var nextBtn = carousel.querySelector('.product-hero__carousel-next');
    var current = 0;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (thumbs[current]) thumbs[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (thumbs[current]) thumbs[current].classList.add('is-active');
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { goTo(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });
  });

  } catch(e) { console.error(e); }
})();
})();
